import { Inject, Injectable, Injector } from '@angular/core';

import { Inventory_FlowService } from './Inventory.flow.index';
import { FootPrintApiManager_FlowService } from './FootPrintApiManager.flow.index';

import { app_hello_worldService } from './app.flow.index';

import { $frontendTypes } from './app.frontend.types'

@Injectable({ providedIn: 'root' })
export class app_FlowService {

  constructor(
    private injector: Injector
  ) {
    this.Inventory = this.injector.get(Inventory_FlowService);
    this.FootPrintApiManager = this.injector.get(FootPrintApiManager_FlowService);
  }

    public Inventory: Inventory_FlowService;
    public FootPrintApiManager: FootPrintApiManager_FlowService;
  public app: app_FlowService = this;

  // injecting lazily in order to avoid circular dependencies
 
  private _hello_world: app_hello_worldService;
  public async hello_world(inParams: { name?: string }): Promise< { message?: string }> {
    if(!this._hello_world) { 
      this._hello_world = this.injector.get(app_hello_worldService);
    }
    return this._hello_world.run(inParams);
  }
   
   

   
}
